import * as actiontype from "../actionType";
import { endPoints } from "../../utils/endPoints";
import { axiosInstanceWithUserToken } from "../../utils/Axios";
import { useNotify } from "../../components/Alert/Alert";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const userProfile = () => (dispatch) => {
    // let toast = useNotify();
    // loadingAction(true)(dispatch);

    dispatch({ type: "LOADER" })
    axiosInstanceWithUserToken
        .get(endPoints.USER_PROFILE, {
            headers: {
                Authorization: `${localStorage.getItem("user_token")}`,
            },
        })
        .then(async (response) => {
            dispatch({ type: "LOADERSTOP" })
            if (response?.data?.status === "success") {
                dispatch({
                    type: actiontype.PROFILE_VIEW,
                    payload: {
                        ...response.data
                    },
                });
            } else {
                // dispatch({
                //     type: actiontype.GET_PROFILE_FAIL,
                //     payload: {
                //         ...response.data
                //     },
                // });
                // toast.error(response?.data?.message);
            }
            // loadingAction(false)(dispatch);
        })
        .catch((errResponse) => {
            dispatch({ type: "LOADERSTOP" })
            if (errResponse?.response?.data?.status === "error") {
                // toast.error(errResponse?.response?.data?.message);
            }
            // dispatch({
            //     type: actiontype.GET_PROFILE_FAIL,
            //     payload: {
            //         payload: {
            //             userData: {}, status: "error"
            //         },
            //     },
            // });
            // loadingAction(false)(dispatch);
        });
};